import React from 'react';
import { Col, EditableInfoComponent, Row } from 'components';
import { ShippingAddressIcon } from 'components/common/icons';
import { AddressAddEditModal } from 'feature/clientTabs/shipping/shippingAddresses/addEdit';
import { DeleteModal } from 'feature/clientTabs/shipping/shippingAddresses/delete';
import { ShippingAddress } from 'feature/clientTabs/shipping/shippingAddresses/shippingAddress';
import { useShippingAddresses } from 'feature/clientTabs/shipping/shippingAddresses/useShippingAddresses';
import { FormattedShippingInfo } from 'typings/client';
import { useAccessControl } from 'components/common/accessControl/useAccessControl';
import { PERMISSIONS } from 'constants/permissions';

export const ShippingAddresses = React.memo(() => {
  const { hasAccess } = useAccessControl();
  const {
    onAddModalStateChange,
    addModalState,
    formattedShippingData,
    onDeleteModalClose,
    isLastAddress,
    isFetching,
    onDeleteModalOpen,
    shippingAddressId,
  } = useShippingAddresses();
  return (
    <>
      <EditableInfoComponent
        title={'Shipping Addresses'}
        icon={<ShippingAddressIcon />}
        creatable={hasAccess(PERMISSIONS.clients.shipping_address.write)}
        editable={false}
        onAdd={onAddModalStateChange}
      />
      <Row>
        <Col span={24}>
          {formattedShippingData.map((_shipping: FormattedShippingInfo) => (
            <ShippingAddress key={_shipping.id} data={_shipping} onDeleteModalOpen={onDeleteModalOpen} />
          ))}
        </Col>
      </Row>
      <AddressAddEditModal onModalStateChange={onAddModalStateChange} modalState={addModalState} />
      <DeleteModal
        openModal={!!shippingAddressId && !isFetching}
        onDeleteModalClose={onDeleteModalClose}
        dataToDelete={{ id: shippingAddressId, isLastAddress }}
      />
    </>
  );
});
